import { Observable } from 'rxjs';
import { PasswordDialogComponent } from './password-dialog.component';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';

@Injectable()
export class PasswordDialogService {

    constructor(private dialog: MatDialog) { }

    public confirm(title: string, message: string): Observable<string> {

        let dialogRef: MatDialogRef<PasswordDialogComponent>;

        dialogRef = this.dialog.open(PasswordDialogComponent);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        return dialogRef.afterClosed();
    }
}
